import { render, staticRenderFns } from "./SpecimenPCR.vue?vue&type=template&id=7f551670"
import script from "./SpecimenPCR.vue?vue&type=script&lang=js"
export * from "./SpecimenPCR.vue?vue&type=script&lang=js"
import style0 from "./SpecimenPCR.vue?vue&type=style&index=0&id=7f551670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports